// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"202":"component---src-templates-list-js","722":"component---src-templates-case-js"}[chunkId] || chunkId) + "-" + {"202":"47a277606a5accb26943","454":"81b0a0e8d8fbc774019d","722":"519dba560d4ae3f623c1"}[chunkId] + ".js";
};